// Modules
import { getCustomTheme } from '@dasa-health/alma-react'
import { navTokens } from '@dasa-health/alma-tokens'

// Applications
import breakPoint from './breakpoints'

export const navTheme = getCustomTheme(navTokens)

const CustomTheme = {
    breakPoint,
}

export default CustomTheme
